import * as React from 'react'
import {Product} from "App/services/api";
import {withTranslation, WithTranslation} from "react-i18next";
import {Ribbon} from "App/fragments/Ribbon";
import {Card, CardBody, CardHeader, CardImg, Col, Row} from "reactstrap";
import {connect} from "react-redux";
import {selectConfigurePageAction} from "App/routes";
import {selectedLang} from "App/helper";
import {DragEventHandler} from "react";
import {Language} from "App/constants";

interface StateToProps {
    product: Product
    catId?: number
    subId?: number
    className: string
    onDragStart?: DragEventHandler;
    onClick?: () => void
}

interface DispatchToProps {
    onChoose: (catId: number, subId:number, prodId:number) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onChoose: (catId: number, subId:number, prodId:number) => dispatch(selectConfigurePageAction(catId, subId, prodId))
});

class _ProductComponent extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.slideNext = this.slideNext.bind(this);
        this.slidePrev = this.slidePrev.bind(this);
    }

    slideNext = () => {
    };
    
    slidePrev = () => {
    };

    render () {
        var {product, catId, subId, className, onChoose, i18n, onDragStart, onClick} = this.props;
        const language: Language = selectedLang(i18n);

        return (<div className={className} key={product.id} onDragStart={onDragStart} onClick={() => catId&&subId?onChoose(catId, subId, product.id):onClick&&onClick()}>
            {product.specialoffer?<Ribbon className={"reactive ribbon-small-" + language}/>:null}
            <Card className="productListWrap">
                <CardHeader className={"text-truncate"}>{product.nameml[language]}</CardHeader>
                <CardImg src={product.iconurl} alt={product.nameml[language]} className="img-fluid p-2"/>
                <CardBody>
                    <Row className="productListInfo">
                        {
                            product.maincharacteristic1nameml?
                            <Col className="col-12 pr-2">
                                <dt>{product.maincharacteristic1nameml[language]}</dt>
                                < dd >{product.maincharacteristic1value}</dd>
                            </Col>
                            :null
                        }
                        {
                            product.maincharacteristic2nameml?
                            <Col className="col-12 pr-2">
                                <dt>{product.maincharacteristic2nameml[language]}</dt>
                                < dd >{product.maincharacteristic2value}</dd>
                            </Col>
                            :null
                        }
                        {
                            product.maincharacteristic3nameml?
                            <Col className="col-12 pr-2">
                                <dt>{product.maincharacteristic3nameml[language]}</dt>
                                < dd >{product.maincharacteristic3value}</dd>
                            </Col>
                            :null
                        }
                    </Row>
                </CardBody>
            </Card>
        </div>);
    }
}

export const ProductComponent = connect(null, mapDispatchToProps)(withTranslation('common')(_ProductComponent));


// WEBPACK FOOTER //
// ./src/components/ProductComponent.tsx